export default __webpack_public_path__ + "static/media/imgVana.89ad1031.webp";